<template>
<div id="addEdit">
  <el-dialog title="编辑资产" :visible.sync="visible" width="700px" @closed="formData.video={}">
    <el-form :model="formData" :rules="rules" ref="form" label-width="100px" size="small">

      <el-form-item label="商品名称" prop="title">
        <el-input v-model="formData.title" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品描述" prop="description">
        <el-input v-model="formData.description" placeholder="请输入商品描述"></el-input>
      </el-form-item>

      <el-form-item label="价格" prop="price">
        <el-input v-model="formData.price" placeholder="请输入商品价格"></el-input>
      </el-form-item>

      <el-form-item prop="category_id" label="分类">
        <el-select v-model="formData.category_id" placeholder="请选择分类" style="width: 100%;">
          <el-option v-for="item in cateList" :key="item.category_id" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="品牌" prop="brand">
        <el-input v-model="formData.brand" placeholder="请输入品牌"></el-input>
      </el-form-item>


      <el-form-item label="成色" prop="fineness_id">
        <el-select v-model="formData.fineness_id" placeholder="请选择成色" style="width: 100%;">
          <el-option v-for="item in finenessList" :key="item.fineness_id" :label="item.name" :value="item.fineness_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="附件" prop="attachment_ids">
         <el-checkbox-group v-model="formData.attachment_ids" style="width: 100%;">
          <el-checkbox v-for="item in attachmentList" :key="item.attachment_id" :label="item.attachment_id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <!-- 发货方式 -->
      <el-form-item label="发货方式" prop="delivery_type">
        <el-radio-group v-model="formData.delivery_type" style="display: inline-block;">
          <el-radio :label="1">包邮</el-radio>
          <el-radio :label="2">自提</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 城市 -->
      <el-form-item label="城市" prop="city_id">
        <el-select v-model="formData.city_id" placeholder="请选择城市" style="width: 100%;">
          <el-option v-for="item in cityList" :key="item.city_id" :label="item.name" :value="item.city_id"></el-option>
        </el-select>
      </el-form-item>



      <el-form-item label="图片" :rules="[{ required: true, message: '请上传图片' }]" prop="images">
      <div class="draggable-list">
        <div class="item" v-for="(item, index) in formData.images" :key="item.file_path">
          <img v-img-url="item.file_path" />
          <a href="javascript:void(0);" class="delete-btn" @click.stop="formData.images.splice(index,1)"><i class="el-icon-close"></i></a>
        </div>
        <div v-if="formData.images.length<8" class="item img-select" @click="isupload=true;uploadKey='images'"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>

    <el-form-item label="视频" prop="video">
      <el-button type="primary" @click="isupload=true;uploadKey='video';config.file_type='video';config.total=1">选择视频</el-button>
      <div v-if="formData.video">
        <el-button type="text" @click="formData.video={}">删除</el-button>
        <div class="img">
          <video :src="formData.video.file_path" width="200" height="100" controls />
        </div>
      </div>
    </el-form-item>

    <el-form-item label="详细地址" prop="address">
      <el-input v-model="formData.address" placeholder="请输入详细地址"></el-input>
    </el-form-item>

    <el-form-item prop="lat" label="位置">
      <Getpoint @chose="choseFunc"></Getpoint>
    </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
    </div>

  </el-dialog>


  <Upload v-if="isupload" :config="config" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


</div>
</template>

<script>
import SecondhandApi from '@/api/secondhand'
import Getpoint from '@/components/map/Getpoint.vue';
import Upload from '@/components/file/Upload';
export default {
  components:{Upload,Getpoint},
  data(){
    return{
      loading:false,
      isupload:false,
      visible:false,
      uploadKey:'',
      uploadType:'images',
      formData:{
        product_id:'',
        category_id:'',
        fineness_id:'',
        title:'',
        description:'',
        price:'',
        brand:'',
        video:{},
        province_id:'',
        city_id:'',
        region_id:'',
        lat:'',
        lng:'',
        address:'',
        delivery_type:'',
        attachment_ids:[],
        images:[],
      },
      rules:{
        title:{required: true,message: '请输入标题'},
        description:{required: true,message: '请输入描述'},
        price:{required: true,message: '请输入价格'},
        brand:{required: true,message: '请输入品牌'},
        video:{required: true,message: '请上传视频'},
        province_id:{required: true,message: '请选择省份'},
        city_id:{required: true,message: '请选择城市'},
        region_id:{required: true,message: '请选择区县'},
        lat:{required: true,message: '请选择位置'},
        fineness_id:{required: true,message: '请选择成色'},
        lng:{required: true,message: '请选择位置'},
        address:{required: true,message: '请输入详细地址'},
        delivery_type:{required: true,message: '请选择发货方式'},
        attachment_ids:{required: true,message: '请选择附件'},
        images:{required: true,message: '请上传图片'},
        category_id:{required: true,message: '请选择分类'},
      },
      config:{
        total: 8,
        file_type: 'image'
      },
    }
  },
  props:{
    cateList:Array,
    finenessList:Array,
    cityList:Array,
    attachmentList:Array,
  },
  methods:{

    // 保存
    submitSave(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let params=JSON.parse(JSON.stringify(this.formData))
          params.attachment_ids=params.attachment_ids.join(',')
          SecondhandApi.secondhandEdit(params).then(result => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$emit('refresh')
            this.visible = false
          }).finally(()=>{
            this.loading = false
          })
        }
      })
    },

    show(e){
      if(e){
        e=JSON.parse(JSON.stringify(e))
        for(let i in this.formData){
          this.formData[i]=e[i]
        }
        // 转成数字类型的数组
        this.formData.attachment_ids=e.attachment_ids.split(',').map(item=>Number(item))
      }
      this.visible=true
    },

    // 图片选择
    uploadChange(e){
      console.log(e);
      let key=this.uploadKey
      if(e&&e!=''){
        if(key!='images'){
          this.formData[key]=e[0];
        }else{
          let max=8-this.formData[key].length
          let eLen=e.length
          if(eLen>max){
            e=e.slice(0,max)
          }
          for(let i in e){
            this.formData[key].push(e[i]);
          }
        }
      }
      this.isupload=false
      this.config.file_type='image'
    },

    choseFunc(e){
      // console.log(e);
      this.formData.lat=e.latitude
      this.formData.lng=e.longitude
      this.formData.address=e.address
    },

  }
}
</script>

<style lang="scss" scoped>
.img{margin-top: 10px;}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/secondhand/product/addEdit.vue